import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph, Tag } from '@digdir/designsystemet-react';
import { ProcessCard } from './ProcessCard';
import classes from '../WorkEnvironmentSurveyProcess.module.css';

type Props = {
  title: string;
  /** Shown above the title when the title is not the survey's own */
  surveyTitle?: string;
  intro: string;
  tag: { label: string; color: 'danger' | 'warning' | 'success' | 'info'; icon?: ReactNode };
  process: Parameters<typeof ProcessCard>[0];
};

/** The title, where the team is in the HMS work, and the process */
export const ProcessHero = ({ title, surveyTitle, intro, tag, process }: Props): ReactElement => {
  const { t } = useTranslation();
  return (
    <section className={classes.hero}>
      <div aria-hidden="true" className={classes.backdrop} />
      <div className={classes.heroContent}>
        <div className={classes.titleRow}>
          <div className={classes.titleText}>
            <span className={`ds-label ${classes.eyebrow}`} data-size="sm">
              {surveyTitle
                ? t('workEnvironmentProcess.eyebrowWithTitle', { title: surveyTitle })
                : t('workEnvironmentProcess.eyebrow')}
            </span>
            <Heading level={1} data-size="xl">
              {title}
            </Heading>
            <Paragraph className={classes.subtle}>{intro}</Paragraph>
          </div>
          <Tag data-color={tag.color} className={classes.statusTag}>
            {tag.icon}
            {tag.label}
          </Tag>
        </div>
        <ProcessCard {...process} />
      </div>
    </section>
  );
};
